import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { MprcContainer, MprcDialogTitleClose, MprcIconButton, MprcJoinComponents, MprcLink, MprcTextMuted } from "components";
import { FeedPanelUserCredentialsResponse, UserCredentialType, UserCredentialTypeSelectorResponse } from "generated/CoreApi_v1";
import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getCredentialIcon } from "views/common/components/CredentialIcon";

interface IProps {
    viewData: FeedPanelUserCredentialsResponse[];
    credentialTypes: UserCredentialTypeSelectorResponse[];
}

/**
 * Painel lateral de credenciais do usuário.
 * @param props
 */
export const PanelUserCredentials: React.FC<IProps> = (props) => {
    const { viewData } = props;
    const { t } = useTranslation("knowledge");

    const credentialTypes = Array.from(new Set(viewData.map((item) => item.credentialType)));
    const [selected, setSelected] = useState<UserCredentialType>(credentialTypes[0]);
    const [dialog, setDialog] = useState<any>();
    const credentials = viewData.filter(x => x.credentialType == selected);

    ///
    const handleMessageDialog = (credential: FeedPanelUserCredentialsResponse) => {
        setDialog(
            <Dialog
                open
                maxWidth="sm"
                onClose={() => setDialog(undefined)}
            >
                <MprcDialogTitleClose
                    title={t("Feed.Panels.UserCredentials.MoreDetailsTitle")}
                    subtitle={credential.title}
                    shrinkPadding
                    onClose={() => setDialog(undefined)}
                />
                <DialogContent sx={{ minWidth: "200px" }}>
                    <MprcTextMuted>
                        <Typography variant="body2">{credential.description}</Typography>
                    </MprcTextMuted>
                </DialogContent>
            </Dialog>
        );
    };

    const RenderData = (credential: FeedPanelUserCredentialsResponse) => {

        const period = credential.startedOn != null && credential.finishedOn != null
            ? `${moment(credential.startedOn).format("MMM/YYYY")} - ${moment(credential.finishedOn).format("MMM/YYYY")}`
            : credential.finishedOn != null
                ? `${t("Literal.Until", { ns: "shared" })} ${moment(credential.finishedOn).format("MMM/YYYY")}`
                : credential.startedOn != null
                    ? `${moment(credential.startedOn).format("MMM/YYYY")} - ${t("Feed.Panels.UserCredentials.Currently")}`
                    : undefined;

        return (
            <Box marginY={1}
                sx={{
                    "&:hover": {
                        cursor: credential.description != null ? "pointer" : "default"
                    },
                }}
                onClick={credential.description != null ? () => handleMessageDialog(credential) : undefined}
            >
                <Typography variant="subtitle1">
                    <b>{credential.title}</b>
                </Typography>

                {

                    <Typography variant="caption" component="div" noWrap={true}>
                        <MprcJoinComponents
                            components={[
                                credential.description ? <MprcLink fontSize="inherit" onClick={() => handleMessageDialog(credential)}>{t("Feed.Panels.UserCredentials.DetailsLinkText")}</MprcLink> : null,
                                period ? period : null
                            ]}
                            separator="&bull;"
                        />
                    </Typography>
                }
            </Box>
        );
    };


    return viewData.length > 0
        ? (
            <>
                {dialog}

                <MprcContainer margin="dense">
                    <Typography variant="h3">{t("Feed.Panels.UserCredentials.Title")}</Typography>
                </MprcContainer>

                <Stack direction="row" justifyContent="flex-start" alignContent="flex-start" flexWrap="wrap">
                    {
                        credentialTypes.map((item, index) =>
                            <MprcIconButton
                                key={index}
                                title={props.credentialTypes.find(x => x.type == item)?.name}
                                color={selected == item ? "primary" : "muted"}
                                size="small"
                                onClick={() => setSelected(item)}
                            >
                                <FontAwesomeIcon icon={getCredentialIcon(item)} size="2x" fixedWidth />
                            </MprcIconButton>
                        )
                    }
                </Stack>

                {
                    credentials?.map((item, index) => {
                        return (
                            <div key={index}>
                                {RenderData(item)}
                            </div>
                        );
                    })
                }

            </>
        )
        : null;
};
